module.exports = __webpack_public_path__ + "components/collectionSearch/select-caret.png";